<template>
  {{ collection.getName(props.item[props.column.key]) }}
</template>

<script setup>

import { getCollection } from '@/kernel/collections';

const props = defineProps({
  column: Object,
  item: Object,
  collection: String
});

const collection = getCollection(props.collection);

</script>